import request from '@/http/request'

export const getAccuracyDetailDroplist = params => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/accuracy/detail/findDropDown`, {
    params
  })
}

export const exportAccuracyDetailPage = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/accuracy/detail/exportAccuracyDetail`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}

export const getAccuracyDetailQuery = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/accuracy/detail/queryAccuracyDetail`,
    params
  )
}
